import { render, staticRenderFns } from "./UnapprovedPOs.vue?vue&type=template&id=05985a0c&scoped=true"
import script from "./UnapprovedPOs.vue?vue&type=script&lang=ts"
export * from "./UnapprovedPOs.vue?vue&type=script&lang=ts"
import style0 from "./UnapprovedPOs.vue?vue&type=style&index=0&id=05985a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05985a0c",
  null
  
)

export default component.exports